import React, {FC, memo, ReactComponentElement, ReactNode, useEffect, useState} from "react";
import {CloseButton, Modal} from "react-bootstrap";
import {useRouter} from "next/router";
import {AnyComponent} from "styled-components/native/dist/types";
import {render} from "react-dom";
import Skeleton from "react-loading-skeleton";
import AttributesList from "./AttributesList";

interface RightModal {
    modalName: string
    className: string
    modalSize?: 'sm' | 'lg' | 'xl'
    closeModal: () => void
    show: boolean
    Title?: ReactNode | null
    loaderStatus?: boolean
    BodyRender?: ReactComponentElement<AnyComponent> | null
    disableClose?: boolean
}

const RightModal: FC<RightModal> =
    (
        {
            modalName,
            className,
            modalSize,
            closeModal,
            show,
            Title,
            BodyRender,
            loaderStatus,
            disableClose = false
        }
    ) => {
        const [showSimpleModal, setShowSimpleModal] = useState<boolean>(show || false);

        const router = useRouter();

        const hasHash = router.asPath.includes( '#' )

        const openHandler = () => {
            if ( !hasHash ) {
                router.push({
                    hash: modalName + ''
                }, undefined, { scroll: false })
            }
            setShowSimpleModal( true );
        }

        const closeHandler = () => {
            if (disableClose) {
                return
            }

            closeModal();
            setShowSimpleModal( false );
        }

        const clickOutSideHandler = () => {
            closeModal();
            setShowSimpleModal( false );
        }

        useEffect( () => {
            if ( show ) openHandler();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [show])

        useEffect( () => {
            if ( !hasHash && showSimpleModal ) clickOutSideHandler();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [hasHash]);

        return (
            <Modal
                key={1000}
                id={modalName}
                className={className}
                size={modalSize}
                show={showSimpleModal}
                onHide={closeHandler}
                animation={true}
            >
                <Modal.Header key={10001}>
                    {
                        disableClose ?
                            <></>
                            :
                            <CloseButton onClick={closeHandler} />
                    }
                    <h3 className={'text-left m-t-0 m-b-0 d-block w-100'}>{Title}</h3>
                </Modal.Header>
                <div className="modal-body">
                    {
                        !loaderStatus ?
                            <>
                                <div className="container p-l-0 p-r-0">
                                    <>
                                        {BodyRender}
                                    </>
                                </div>
                            </> :
                            <>
                                <div className="container p-t-20">
                                    <Skeleton height={340} className="col-12 b-rad-lg d-block"/>
                                    <Skeleton height={27} className="col-12 b-rad-lg d-block"/>
                                    <Skeleton height={27} className="col-12 b-rad-lg d-block"/>
                                </div>
                            </>
                    }
                </div>
            </Modal>
        )

    }

export default memo( RightModal );